import type { ThemeConfig } from 'antd';
// import { montserrat } from '../ui/fonts';

const theme: ThemeConfig = {
  token: {
    fontFamily: "'SF Pro', sans-serif",
    red5: '#E55A53',
    red2: '#FECBC9',
    blue6: '#2563EB',
    blue2: '#BFDBFE',
    green5: '#48AB93',
    fontSize: 16,
    // colorPrimary: '#E55A53',
    // colorFill: '#FECBC9',
    // colorWarning: '#2563EB',

    // colorTextBase: '#3b4541',
    // fontFamily: montserrat.style.fontFamily,
    // colorBgContainer: '#a3aca6',
    // },
    // components: {
    // Carousel: {
    /* here is your component tokens */
    // dotHeight: 10,
    // },
    paddingLG: 10,
    padding: 8,
  },
  components: {
    Input: {
      fontSize: 16,
    },
    Select: {
      fontSize: 16,
    },
    // Button: {
    //   colorPrimary: '#E55A53',
    // },
  },
};

export default theme;
